<template>
   <div class="backgroundImageOfLoginPage">
    </div>
</template>

<script>
export default {
  name: "userMsg",
  data() {
    return {
      action:0
    };
  },
  created() {
    // 在created钩子中获取参数
  },
  methods: {
    showMsg() {
      console.log(this.action);
        if(this.action==1){
           this.$message.success("上班打卡成功，时间已记录");
           setTimeout(() => {
             window.close();
            },1000)
        }
        else{
             window.close();
        }
    },

  },
  mounted() {
    this.action = this.$route.query.action;
    // this.autoScroll();
    this.showMsg();
  },
};
</script>




// WEBPACK FOOTER //
// src/views/userMsg/index.vue